// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"16299952","150":"046a3b0b","587":"7cf4ca75","611":"cd9f5f5b","675":"1df19d01","731":"31d6cfe0","773":"428027cc"}[chunkId] + ".chunk.css";
};